import { MessageSquare, MessageSquarePlus } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '@caruso/ui';

interface EmptyStateProps {
  onNewConversation?: () => void;
}

export function EmptyState({ onNewConversation }: EmptyStateProps) {
  return (
    <div className="flex-1 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-brand-gold/10 flex items-center justify-center">
          <MessageSquare className="w-12 h-12 text-brand-gold/50" />
        </div>
        <h3 className="text-xl font-serif text-brand-ivory mb-2">
          Selecione uma conversa
        </h3>
        <p className="text-brand-ivory/50 max-w-xs mx-auto mb-6">
          Escolha uma conversa na lista ao lado para visualizar as mensagens e interagir com o cliente.
        </p>
        {onNewConversation && (
          <Button
            onClick={onNewConversation}
            className="bg-brand-gold text-brand-ink hover:bg-brand-gold/90"
          >
            <MessageSquarePlus className="w-5 h-5 mr-2" />
            Nova Conversa
          </Button>
        )}
      </motion.div>
    </div>
  );
}
